import { formatearFechaConHora, formatearFechaSinHora } from "@shared/utils/date.utils";
import IArchivo, { IS3 } from "./archivo.interface";
import IEstado from "./estado.interface";
import { TipoDocumento } from "./tipo-documento.model";
import { Usuario } from "./usuario.model";

export class Archivo implements IArchivo {
    id: number;
    uuid: number;
    nombre: string;
    ruta: string;
    requerido: boolean;
    usuario_creador: Usuario;
    usuario_actualizador: Usuario;
    tipo: TipoDocumento;
    estado: IEstado;
    base64: string;
    mime: string;
    fecha_ingreso: string;
    fecha_actualizacion: string;
    s3: IS3;

    constructor() {
        if (this.ruta && !this.nombre)
            this.nombre = this.ruta.split(/[/\\]/).pop();
    }

    get nombre_base() {
        if (!this.nombre) return "";
        return this.nombre.substring(0, this.nombre.lastIndexOf("."));
    }

    get extension() {
        if (!this.nombre) return "";
        return this.nombre.substring(this.nombre.lastIndexOf(".") + 1);
    }
    
    get fecha_ingreso_formateado() {
        return formatearFechaConHora(this.fecha_ingreso);
    }
    
    get fecha_ingreso_sin_hora() {
        return formatearFechaSinHora(this.fecha_ingreso);
    }
    
    get fecha_actualizacion_formateado() {
        return formatearFechaConHora(this.fecha_actualizacion);
    }
    
    get fecha_actualizacion_sin_hora() {
        return formatearFechaSinHora(this.fecha_actualizacion);
    }
    
    get fecha_actualizacion__s3_formateado() {
        if (!this.s3) return "";
        return formatearFechaConHora(this.s3.ultima_modificacion);
    }
    
    get fecha_actualizacion_s3__sin_hora() {
        if (!this.s3) return "";
        return formatearFechaSinHora(this.s3.ultima_modificacion);
    }

    get url_documento() {
        if (!this.s3 || !this.s3.base64) return this.ruta;
        return `data:${this.s3.type};base64,${this.s3.base64}`;
    }

    get mime_type() {
        if (this.s3 && this.s3.type) return this.s3.type;
        return this.mime;
    }
}
